import { DoorPayment } from './doorApi';

export const euro = (cents: number) => `${(cents / 100).toFixed(2).replace('.', ',')} €`;

export const persons = (n: number) => `${n} ${n === 1 ? 'Person' : 'Personen'}`;

export const bookings = (n: number) => `${n} ${n === 1 ? 'Buchung' : 'Buchungen'}`;

const WEEKDAYS = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];

export const eventDate = (date: string) => {
  const [y, m, d] = date.split('-').map(Number);
  if (!y || !m || !d) return date;
  const weekday = WEEKDAYS[new Date(Date.UTC(y, m - 1, d)).getUTCDay()];
  return `${weekday} ${String(d).padStart(2, '0')}.${String(m).padStart(2, '0')}.${y}`;
};

export const clock = (at: number) =>
  new Intl.DateTimeFormat('de-DE', { timeZone: 'Europe/Berlin', hour: '2-digit', minute: '2-digit' }).format(new Date(at));

/** Short German payment line; "paid" alone never says FULLY PAID for a deposit. */
export const paymentLine = (payment: DoorPayment) => {
  switch (payment.kind) {
    case 'guestList':
      return 'Gästeliste · ohne Ticket';
    case 'free':
      return 'Kostenlos';
    case 'paid':
      return `Voll bezahlt (${euro(payment.paidCents)})`;
    case 'deposit':
      return `Anzahlung ${euro(payment.paidCents)} – offen ${euro(payment.outstandingCents)}`;
    case 'payAtVenue':
      return `Zahlung vor Ort – offen ${euro(payment.outstandingCents)}`;
    default:
      return `Offen ${euro(payment.outstandingCents)}`;
  }
};
